exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header .user-header{height:2.25rem;padding:.625rem 2rem;font-size:13px;line-height:1rem;color:#fff;background-color:#333}.header .user-header .user-info{float:right}.header .user-header .user-info a{margin-left:1rem;color:#FB5D2D}.header .admin-header{padding:1rem;border-bottom:1px solid #e5e5e5;background-color:#FB5D2D}\n", ""]);

// exports
